import { createSlice } from '@reduxjs/toolkit'
import { ThunkHttpClient } from '../../utils/httpThunkClient'
import { groupBy, groupByValue } from '../../utils/CommonFn'

export const getAllActiveTicketCategory = ThunkHttpClient.get('master/getAllActiveTicketCategory', () => ("master/getAllActiveTicketCategory"))
export const saveOrUpdateTicketCategory = ThunkHttpClient.post('master/saveOrUpdateTicketCategory', (body) => ({url:'master/saveOrUpdateTicketCategory', body}))

export const saveOrUpdateTour = ThunkHttpClient.post('master/saveOrUpdateTour', (body) => ({url:'master/saveOrUpdateTour', body}))

export const getAllTours = ThunkHttpClient.get('master/getAllTour', (status) => `master/getAllTourAndTicket`);

export const getAllActiveSupplier = ThunkHttpClient.get('master/fetchAllActiveSupplierData', () => ("master/fetchAllActiveSupplierData"))

export const fetchCategoryProductName = ThunkHttpClient.get('master/fetchCategoryProductName', () => ("master/fetchCategoryProductName"))

export const fetchAllUsers = ThunkHttpClient.get('users/list', () => ("users/list"))


const initialState = {
    loading: false, 
    error: null,
    tourCategoryData: [],
    tourData: [],
    supplierData: [],
    productNames: [],
    userList: []
} as any

export const ticketAndTourSlice = createSlice({
    name: 'ticketAndTour',
    initialState,
    reducers: {},
    extraReducers: (builder) => {

        // Save or Update Ticket Category
        builder.addCase(saveOrUpdateTicketCategory.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(saveOrUpdateTicketCategory.fulfilled, (state, action) => {
            state.loading = false;
        })
        builder.addCase(saveOrUpdateTicketCategory.rejected, (state, action) => {
            state.loading = false;
        })

        // Get All Ticket Category
        builder.addCase(getAllActiveTicketCategory.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(getAllActiveTicketCategory.fulfilled, (state, action) => {
            state.loading = false;
            state.tourCategoryData = action.payload.data;
        })
        builder.addCase(getAllActiveTicketCategory.rejected, (state, action) => {
            state.loading = false;
        })

        // Save or Update Tour
        builder.addCase(saveOrUpdateTour.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(saveOrUpdateTour.fulfilled, (state, action) => {
            state.loading = false;
        })
        builder.addCase(saveOrUpdateTour.rejected, (state, action) => {
            state.loading = false;
        })

        // Get All Tours
        builder.addCase(getAllTours.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(getAllTours.fulfilled, (state, action) => {
            state.loading = false;
            state.tourData = action.payload.data;
            state.tourDataById = groupByValue(action.payload.data, (item:any)=>item.id, g => g[0]);
        })
        builder.addCase(getAllTours.rejected, (state, action) => {
            state.loading = false;
        })

        // Get All Supplier
        builder.addCase(getAllActiveSupplier.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(getAllActiveSupplier.fulfilled, (state, action) => {
            state.loading = false;
            state.supplierData = action.payload.data;
        })
        builder.addCase(getAllActiveSupplier.rejected, (state, action) => {
            state.loading = false;
        })

        // Get All Product Type
        builder.addCase(fetchCategoryProductName.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(fetchCategoryProductName.fulfilled, (state, action) => {
            state.loading = false;
            state.productNames = action.payload.data;
        })
        builder.addCase(fetchCategoryProductName.rejected, (state, action) => {
            state.loading = false;
        })

        // Get All Users
        builder.addCase(fetchAllUsers.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(fetchAllUsers.fulfilled, (state, action) => {
            state.loading = false;
            state.userList = action.payload.data;
        })
        builder.addCase(fetchAllUsers.rejected, (state, action) => {
            state.loading = false;
        })
    }
})

export default ticketAndTourSlice.reducer
